export default {
    data: {
        login: false,
        registration: false,
        password: false,
        alert: false,
        search: false,
    },
    activeKey: '',

    open(key) {
        for (let dataKey in this.data) {
            if(dataKey !== key) {
                this.close(dataKey);
            }
        }

        this.activeKey = key;
        this.data[key] = true;
        this.get(key).classList.add('active');
    },

    close(key) {
        this.activeKey = '';
        this.data[key] = false;
        this.get(key).classList.remove('active');
    },

    toggle(key) {
        if (! this.data[key]) {
            this.open(key);
        }
        else {
            this.close(key);
        }
    },

    get(key) {
        return document.querySelector('[data-key="' + key + '"]');
    }
}
